import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ActivityParticipantGroup } from "web_myplann/Activities/Components/ActivityParticipantGroup";
import type { useActivityParticipantGroups } from "web_myplann/Activities/Hooks/useActivityParticipantGroups";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Activity.Detail;

type Props = {
	groups: ReturnType<typeof useActivityParticipantGroups>;
};

export const ActivityParticipantsSection: FC<Props> = ({ groups }) => {
	const { t } = useResource();

	if (groups.length === 0) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">{t(R.Participants.title)}</Typography>
			<Stack bgcolor="background.paper" px={1.6} py={1.2} gap={1.2}>
				{groups.map((group) => (
					<ActivityParticipantGroup
						key={group.role}
						role={group.role}
						names={group.names}
					/>
				))}
			</Stack>
		</>
	);
};
